function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/* eslint-disable */
// This icon has been generated. Do not edit it directly.
import React from 'react';
var IconTwitter = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconTwitter, _React$PureComponent);
  function IconTwitter() {
    _classCallCheck(this, IconTwitter);
    return _possibleConstructorReturn(this, _getPrototypeOf(IconTwitter).apply(this, arguments));
  }
  _createClass(IconTwitter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        color = _this$props.color,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);
      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "0 0 512 512"
      }), React.createElement("path", {
        d: "M442.896 130.755c-13.818 6.68-28.529 11.008-44.111 13 15.879-10.224 28.061-26.314 33.83-45.6-14.848 9.411-31.287 16.142-48.793 20.07-13.943-16.109-33.945-26.166-55.938-26.166-42.359 0-76.683 36.926-76.683 82.577 0 6.412.654 12.755 1.924 18.719-63.608-3.274-120.204-36.279-158.047-86.138-6.578 12.169-10.337 26.314-10.337 41.501 0 28.586 13.516 54.001 34.14 68.586-12.606-.502-24.432-4.019-34.747-10.257v1.122c0 39.932 26.424 73.247 61.495 80.963-6.423 1.866-13.212 2.726-20.258 2.726-4.923 0-9.599-.344-14.334-1.466 9.715 32.914 38.066 56.83 71.612 57.312-26.247 22.268-59.304 35.342-95.235 35.342-6.2 0-12.336-.366-18.312-1.156 33.929 23.525 74.163 37.241 117.553 37.241 141.045 0 218.221-125.841 218.221-234.936 0-3.479-.08-7.029-.254-10.555 14.978-11.808 27.993-26.365 38.274-42.885"
      }));
    }
  }]);
  return IconTwitter;
}(React.PureComponent);
_defineProperty(IconTwitter, "styleRoot", 'IconTwitter');
_defineProperty(IconTwitter, "defaultProps", {
  size: 32,
  color: '#333'
});
export { IconTwitter as default };